// Payment route slugs - used by middleware for path detection
export const PaymentSlugs = Object.freeze({
  PAYMENT: `/payment`,
  PAYMENT_CONFIRM: `/payment/confirm`,
  ABOUT_BAMBEE_PAYMENT: `/about-bambee/payment`,
  // $1 Premium People trial lead landing (BIO-1350). Listed here so isAnUnpaidAppPath treats it as
  // a lead-reachable path and the unpaid/lead middleware does not bounce anonymous visitors.
  TRIAL_PREMIUM_PEOPLE: `/trial/premium-people`,
});

export default null;
